<template>
  <div>
    <Head title="Borang Aduan" />
    <form @submit.prevent="store">
      <div class="flex items-center py-4 bg-gray-50 border-t border-gray-100">
            <h1 style="width: 100%;" class="w-100 mt-6 pb-10 text-3xl font-bold">
              <Link class="text-indigo-400 hover:text-indigo-600" href="/issues"><small>Senarai Aduan</small></Link>
              <span class="text-indigo-400 font-medium"> |</span> Borang Aduan <span class="text-sm pl-8">( Status Aduan : {{ getCurrentProcess(issues.current_stat, issues) }} )</span>
            </h1>
                    
            <a class="btn-indigo cursor-pointer flex items-center px-6 py-4 mr-6 focus:text-indigo-500" @click="generateCertificate('REF-LETTER')">
              <icon name="adobe" class="mr-2 w-4 h-4 fill-white" />
              Surat Rujukan
            </a>
            
            <a v-if="owner" class="btn-indigo cursor-pointer flex items-center pl-6 py-4 focus:text-indigo-500" :href="`/issues/${issues.id}/review`">
              <icon name="process" class="mr-2 w-4 h-4 fill-white" />Ulasan Aduan
            </a>
        </div>       
      
    <div class="bg-white rounded-md shadow overflow-hidden">     

            <div class="bg-gray-300 pb-4 pt-6 px-6 text-center font-bold text-2xl">👤 BUTIR-BUTIR PENGADU</div>

            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <text-input required v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" label="*Nama Pengadu " />
              <select-input v-model="form.category" :error="form.errors.category" class="pb-8 pr-6 w-full lg:w-1/2" label="Kategori Pengadu ">
                <option :value="null" />
                  <option value="warga">Warga ECoS</option>
                  <option value="awam">Orang Awam</option>
              </select-input>
              <select-input v-model="form.seconded" :error="form.errors.category" class="pb-8 pr-6 w-full lg:w-1/2" label="Jenis Aduan ">
                  <option value="baru">Aduan Baru</option>
                  <option disabled value="null">------ Aduan Susulan ------</option>
                  <option
                    v-for="issue in issues.issues_reff.filter(i => i.details && i.details !== 'null')"
                    :key="issue.id"
                    :value="issue.id"
                  >
                  {{ issue.details }} - Tarikh : {{ formatDate(issue.created_at) }}
                  </option>                  
              </select-input>              
              <text-input v-model="form.ic_no" :error="form.errors.ic_no" class="pb-8 pr-6 w-full lg:w-1/2" label="No. MyKad " />
              <text-input v-model="form.age" :error="form.errors.age" class="pb-8 pr-6 w-full lg:w-1/2" label="Umur " />
              <text-input v-model="form.passport_no" :error="form.errors.passport_no" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Passport " />
              <select-input v-model="form.gender" :error="form.errors.gender" class="pb-8 pr-6 w-full lg:w-1/2" label="Jantina ">
                  <option :value="null" />
                  <option value="lelaki">Lelaki</option>
                  <option value="perempuan">Perempuan</option>
              </select-input>
              <text-input v-model="form.race" :error="form.errors.race" class="pb-8 pr-6 w-full lg:w-1/2" label="Bangsa " />
              <text-input v-model="form.nationality" :error="form.errors.nationality" class="pb-8 pr-6 w-full lg:w-1/2" label="Warganegara " />
              <text-input required v-model="form.phoneno_1" :error="form.errors.phoneno_1" class="pb-8 pr-6 w-full lg:w-1/2" label="*No. Telefon (1) " />
              <text-input v-model="form.phoneno_2" :error="form.errors.phoneno_2" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Telefon (2) " />
              <text-input required v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full" label="Alamat Surat Menyurat " />
              <text-input required v-model="form.occupation" :error="form.errors.occupation" class="pb-8 pr-6 w-full lg:w-1/2" label="Pekerjaan " />
              <text-input required v-model="form.employer" :error="form.errors.employer" class="pb-8 pr-6 w-full lg:w-1/2" label="Agensi / Majikan " />  
              
            </div>

            <div class="bg-gray-300 pb-4 pt-6 px-6 text-center font-bold text-2xl">⚠️ Maklumat Aduan</div>                  
  
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <text-input required v-model="form.location" :error="form.errors.location" class="pb-8 pr-6 w-full" label="Tempat Kejadian" />
              <text-input required v-model="form.details" :error="form.errors.details" class="pb-8 pr-6 w-full" label="Keterangan Aduan" />             
              <Datepicker 
                class="pt-4 pb-8 pr-4 lg:w-1/2"
                v-model="form.date_incident" 
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Kejadian"></Datepicker>

                <Datepicker 
                  class="pt-4 pb-8 pr-4 lg:w-1/2"
                  v-model="form.time_incident"
                  timePicker 
                  :is24="false"
                  value-type="hh:mm:ss"
                  :disableTimeRangeValidation = false
                  @closed="runme()" 
                  placeholder="Masa Kejadian"></Datepicker> 

            </div>

            <div class="flex items-center justify-between mt-6">
              

              <span class="group flex items-center py-3 mb-6 pl-8">
                <icon name="upload" class="mr-4 w-8 h-8 text-gray-700"/>
                <h1 class="text-2xl font-bold">Muatnaik Dokumen/Fail</h1>
              </span> 

              <a v-if="!owner && form.isDraft" class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formUpload">
                <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
              </a> 
            </div>
            
            <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-4 pt-6 px-6 text-center">Deskripsi / Ulasan</th>
                  <th class="pb-4 pt-6 px-6 text-center">Jenis Rekod</th>
                  <th class="pb-4 pt-6 px-6 text-center">Tindakan</th>
                </tr>
                <tr v-for="upload in uploads" :key="upload.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t py-2 pb-2 pl-6">
                    <span class="flex">{{ upload.description }}</span>
                    <icon v-if="upload.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </td>
                <td class="border-t text-center">                
                  <a class="cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" target="_blank" :href="upload.upload_path">
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Lihat Rekod 
                  </a>                          
                </td>
                <td class="border-t text-center">
                  <div class="text-center">
                  <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadUpload(upload)">
                    <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Edit 
                  </a>                
                </div>                      
                </td>
              </tr>
              <tr v-if="uploads.length === 0">
                <td class="px-6 py-4 border-t" colspan="5">
                  <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    Tiada rekod muatnaik dokumen/fail.&nbsp;&nbsp;
                    <a class="cursor-pointer text-indigo-500" @click="formUpload()">
                      <strong>Muatnaik Dokumen/Fail</strong>
                    </a>
                  </span>               
                </td>
              </tr>                
              </table>
            </div>

            <div class="flex items-center justify-between mt-6">
              <span class="group flex items-center py-3 mb-6 pl-8">
                <icon name="profile" class="mr-4 w-8 h-8 text-gray-700"/>
                <h1 class="text-2xl font-bold">Orang Yang Di Adu</h1>
              </span> 
              <a v-if="!owner && form.isDraft" class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formIndividual">
                <icon name="profile" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
              </a> 
            </div>

            <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-4 pt-6 px-6 text-center">Nama Orang Yang Di Adu</th>
                  <th class="pb-4 pt-6 px-6 text-center">Nama Agensi / Syarikat</th>
                  <th class="pb-4 pt-6 px-6 text-center">Jawatan</th>
                  <th class="pb-4 pt-6 px-6 text-center">Tindakan</th>
                </tr>
                <tr v-for="individual in individuals" :key="individual.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t py-2 pb-2 pl-6">
                    <span class="flex">{{ individual.name }}</span>
                    <icon v-if="individual.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </td>
                <td class="border-t">
                  <span>{{ individual.agency }}</span>     
                </td>
                <td class="border-t text-center">
                  <span>{{ individual.position }}</span>                
                </td>
                <td class="border-t text-center">
                  <div class="text-center">
                  <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadIndividual(individual)">
                    <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Edit 
                  </a>                
                </div>                      
                </td>
              </tr>
              <tr v-if="individuals.length === 0">
                <td class="px-6 py-4 border-t" colspan="5">
                  <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    Tiada rekod orang yang di adu.&nbsp;&nbsp;
                    <a class="cursor-pointer text-indigo-500" @click="formIndividual()">
                      <strong>Tambah rekod</strong>
                    </a>
                  </span>               
                </td>
              </tr>
              </table>
            </div>

            <div v-if="!owner" class="flex items-center py-6 px-4 bg-gray-50 border-t border-gray-100">
              <!-- Left group: Exit + Save Draft -->
              <div v-if="isDraft" class="flex items-center space-x-2">
                <a class="cursor-pointer text-indigo-400 hover:text-indigo-600 text-xl font-bold" @click.prevent="goBack"><small>Kembali</small></a>
                <span class="text-indigo-400 text-xl">|</span>
                <button type="button" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500"> 
                  <icon name="save" class="mr-4 w-4 h-4 bf-w fill-white"/>Simpan Rekod
                </button>
              </div>

              <!-- Right group: Submit Complaint -->
              <div v-if="isDraft" class="ml-auto">
                <button type="button" class="btn-action cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="submitForm()"> 
                  <icon name="send" class="mr-4 w-4 h-4 bf-w fill-white"/>Hantar Aduan
                </button> 
              </div>
            </div>              
            
    </div>

    </form>

    <Modal @close="toggleUpload" :modalActive="modalUpload" @submit="updateUpload" submitLabel="Tambah" closeLabel="Tutup">
      <div class="mx-6 pb-4">
          <span class="group flex items-center py-3 mb-6">
            <icon name="upload" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Muatnaik Dokumen/Fail</h1>
            <button v-if="!owner && form.isDraft" class="btn-action cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('uploads', form.upload_id)">
              <icon name="trash" class="w-4 h-4 fill-white mr-2" /> Delete Record
            </button>
          </span>  
          <div class="flex flex-wrap mr-6 p-8">
            <table class="w-full whitespace-nowrap">
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-l border-t pl-4">
                  <text-input :readonly="owner && form.isDraft" :disabled="owner && form.isDraft" v-model="form.upload_description" :error="form.errors.upload_description" class="py-2 w-full" label="Deskripsi / Ulasan" />            
                </td>
                <td class="border-t border-r pl-4">
                  
                  <div v-if="file_attached" class="flex items-center">
                    <span style="width: 100%;" class="w-100 text-3xl font-bold">
                      <a   @click="loadAttachment('file_attached', form.upload_path)" class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500"> 
                      <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                        View Document 
                      </a> 
                    </span>
                  </div>
                  <file-input v-if="!file_attached" v-model="form.upload_attachments" :error="form.errors.upload_attachments" class="py-2 w-full" type="file" accept="application/pdf,image/*,video/*" label="*📎 Dokumen/ Fail (pdf, imej, video)" />
                </td>             
              </tr>
            </table>          
          </div> 
      </div>    
    </Modal>    

    <Modal @close="toggleIndividual" :modalActive="modalIndividual" @submit="updateIndividual" submitLabel="Tambah" closeLabel="Tutup">
      <div class="mx-6 pb-4">
          <span class="group flex items-center py-3 mb-6">
            <icon name="profile" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Orang Yang Di Adu</h1>
            <button v-if="!owner && form.isDraft" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('individual', form.individual_id)">
              <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
            </button>
          </span>  
          <div class="flex flex-wrap mr-6 p-8"> 
            <text-input :readonly="!owner && form.isDraft" :disabled="!owner && form.isDraft" v-model="form.individual_name" :error="form.errors.individual_name" class="pb-8 pr-6 w-full" label="Nama" />
            <text-input :readonly="!owner && form.isDraft" :disabled="!owner && form.isDraft" v-model="form.individual_agency" :error="form.errors.individual_agency" class="pb-8 pr-6 w-full lg:w-1/2" label="Agensi / Syarikat " />
            <text-input :readonly="!owner && form.isDraft" :disabled="!owner && form.isDraft" v-model="form.individual_position" :error="form.errors.individual_position" class="pb-8 pr-6 w-full lg:w-1/2" label="Jawatan " />
          </div> 
      </div>    
    </Modal> 

    <Modal @close="toggleSubmit" :modalActive="modalSubmit" @submit="submitComplaints" submitLabel="Hantar">
      <div class="mx-6">
        <span class="flex items-center py-2 text-2xl font-bold">
          <icon name="comfirm" class="mr-2 w-12 h-12 fill-indigo-400" /> 
          Sahkan penghantaran borang aduan ini?
        </span> 

        <div class="text-center">
          <img class="block mx-auto my-10" src="/images/confirm-record.jpg" />
        </div>
        
        <span class="block text-center text-base text-gray-700 mb-6 text-xl">
          <p>Sila pastikan semua maklumat yang diperlukan dan dokumen sokongan telah disertakan. Teruskan untuk menghantar laporan ini?</p>
          <p class="pt-4">Klik butang "hantar" bagi meneruskan penghantaran.</p>
        </span>
      </div>
    </Modal>    
    
    <Modal @close="closeProcessForm" :modalActive="modalProcess" @submit="closeProcessForm">
      <div class="mx-6">
        <h1 class="text-2xl font-bold">📜&nbsp;Process Complaint</h1>
                  
        <!-- process -->

        <div v-if="form.status == 'approved'" class="flex items-center justify-between mt-4 p-4 bg-gray-100 rounded"> 
          <text-input v-model="form.certification" :error="form.errors.certification" class="pb-4 pr-6 w-full lg:w-1/2" label="ECoS ESCO ID " />
          <text-input v-model="form.expiry" :error="form.errors.expiry" class="pb-4 pr-6 w-full lg:w-1/2" label="Expiry ~ One (1) year upon approval " />
        </div> 

        <div class="flex items-center justify-between mt-4 p-4 bg-gray-100 rounded">
          <text-input v-model="form.message" :error="form.errors.message" class="pb-4 pr-4 w-full" label="Ringkasan Maklumat Aduan" />
          <select-input @change="changeStatus" v-model="form.status" :error="form.errors.status" class="pb-4 pr-6 w-full lg:w-1/2" label="Status ">
            <option v-for="operation in operations" :key="operation" :value="operation">{{ operation }}</option>
          </select-input>
          <loading-button :loading="form.processing" class="btn-action ml-auto" type="button" @click="updateSubmission">💬&nbsp;Update Status</loading-button>
        </div>
      
      </div>
    </Modal>     

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Layout from '@/Shared/Layout'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import {FormWizard, TabContent} from 'vue3-form-wizard'
import '../../../../node_modules/vue3-form-wizard/dist/style.css'
//import '../../../../node_modules/vue-form-wizard/dist/vue-form-wizard.js'
import Icon from '@/Shared/Icon'
import Modal from "@/Shared/Modal.vue"
import axios from 'axios'
import AvatarInput from '@/Shared/AvatarInput'
import { Vue3ToggleButton } from 'vue3-toggle-button'
import '../../../../node_modules/vue3-toggle-button/dist/style.css'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    FileInput,
    FormWizard,
    AvatarInput,
    TabContent,
    Modal,
    Icon,
    Vue3ToggleButton,
    Datepicker,
  },
  setup() {
    const modalIndividual = ref(false);
    const modalUpload = ref(false);
    const modalSubmit = ref(false); 
    const modalProcess = ref(false); 

    const toggleIndividual = () => {
      modalIndividual.value = !modalIndividual.value;
    };

    const toggleUpload = () => {
      modalUpload.value = !modalUpload.value;
    };

    const toggleSubmit = () => {
      modalSubmit.value = !modalSubmit.value;
    };

    const toggleProcess = () => {
      modalProcess.value = !modalProcess.value;
    };

    return { modalIndividual, toggleIndividual,
             modalUpload, toggleUpload,
             modalSubmit, toggleSubmit,
             modalProcess, toggleProcess
           };
  },  
  layout: Layout,
  props: {
    issues: Object,
    owner: {
      type: [Object, Boolean], // Accepts both
      default: () => false
    }
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        issue_id: this.issues.id,
        category: this.issues.category,
        seconded: this.issues.seconded,
        name: this.issues.name,
        ic_no: this.issues.ic_no,
        age: this.issues.age,
        passport_no: this.issues.passport_no,
        gender: this.issues.gender,
        race: this.issues.race,
        nationality: this.issues.nationality,
        phoneno_1: this.issues.phoneno_1,
        phoneno_2: this.issues.phoneno_2,
        address: this.issues.address,
        occupation: this.issues.occupation,
        employer: this.issues.employer,
        location: this.issues.location,
        details: this.issues.details,
        date_incident: this.issues.date_incident, 
        time_incident: this.getIncidentTime(this.issues.time_incident),
        individual_name: null,
        individual_agency: null,
        individual_position: null,
        upload_description: null,
        upload_attachments : null,
        submitting : false,
        isDraft : this.issues.is_draft,
      }),
      issues_id: this.issues.id, //Interim REEM ID
      owner_id: "0",
      individual: "", 
      individuals:this.issues.individuals, 
      upload: "",  
      uploads: this.issues.uploads,
      file_attached: false,
      operations : [],
      originalForm: {}, // to store initial form state
      streams : false, 
    }
  },
  mounted(){ 
      this.originalForm = JSON.parse(JSON.stringify(this.form));
      let action = this.issues.action;
      action.forEach((item) => {
        this.operations.push(item.action)      
      });
      this.progress = this.operations
      console.log(this.issues);
  },
  methods: {
    filter() {
      // Compare current form with originalForm
      const hasChanged = Object.keys(this.form).some(key => {
        // Handle objects/dates separately if needed
        if (this.form[key] instanceof Date && this.originalForm[key] instanceof Date) {
          return this.form[key].getTime() !== this.originalForm[key].getTime();
        }
        return this.form[key] !== this.originalForm[key];
      });

      this.streams = hasChanged;
      return hasChanged;
    },    
    goBack(){
      if(this.filter()){
        this.store()
      }
      window.history.back()
    },
    store() {

      let parse_time = JSON.parse(JSON.stringify(this.form.time_incident))

      const formData = new FormData();
      formData.append('type', this.streams);
      formData.append('issues_id',this.issues_id);
      formData.append('category',this.form.category);
      formData.append('name',this.form.name);
      formData.append('ic_no',this.form.ic_no);
      formData.append('age',this.form.age);
      formData.append('passport_no',this.form.passport_no);
      formData.append('gender',this.form.gender);
      formData.append('race',this.form.race);
      formData.append('nationality',this.form.nationality);
      formData.append('phoneno_1',this.form.phoneno_1);
      formData.append('phoneno_2',this.form.phoneno_2);
      formData.append('address',this.form.address);
      formData.append('occupation',this.form.occupation);
      formData.append('employer',this.form.employer);
      formData.append('location',this.form.location);
      formData.append('details',this.form.details);
      formData.append('date_incident', moment(this.form.date_incident).format("yyyy-MM-DD"));
      formData.append('time_incident', parse_time.hours + ":" + parse_time.minutes);
      
      axios.post(`/issues`, formData)
          .then(response => {

            if(response.data.status === 'success'){
              this.issues_id = response.data.issues_id;
              this.owner_id = response.data.owner_id;
              
              if(this.uploads.length>0){
                this.uploads.forEach((upload) => {
                  const formData = new FormData();
                  formData.append('owner_id', this.owner_id);
                  formData.append('issues_id', this.issues_id);
                  formData.append('upload', upload.upload);
                  formData.append('id', upload.id);
                  formData.append('upload_description', upload.description);
                  formData.append('upload_filetype', upload.filetype);
                  formData.append('upload_path', upload.path);
                  formData.append('upload_attachments', upload.fileObj);
                  axios.post(`/issues/${this.issues_id}/uploads`, formData).then(response => {}).catch(error => { });
                }); 
              }

              if(this.individuals.length>0){
                this.individuals.forEach((individual) => {
                  const formData = new FormData();
                  formData.append('owner_id', this.owner_id);
                  formData.append('issues_id', this.issues_id);
                  formData.append('individual', individual.individual);
                  formData.append('id', individual.id);
                  formData.append('individual_name', individual.name);
                  formData.append('individual_agency', individual.agency);
                  formData.append('individual_position', individual.position);
                  axios.post(`/issues/${this.issues_id}/individuals`, formData).then(response => {}).catch(error => { }); 
                });
              }

              this.$page.props.flash.success = response.data.message

            }
          })
          .catch(error => { });

      
    },
    async mediaUploaded(e){    
      this.media = JSON.parse(JSON.stringify(e));
    },
    submitForm(){      
      this.toggleSubmit();  
    },
    submitComplaints() {
      this.form.submitting = true;
      this.form.post(`/issues/${this.issues.id}/submission`, {
        onSuccess: () => {
          this.form.submitting = false
          this.toggleSubmit();
          setTimeout(() => {
            if (window.history.length > 1) {
              sessionStorage.setItem("callback", "reload");
              history.back();
            }
          }, 2000); // 2-second delay
          
        },
      }) 
    },    
    generateCertificate(target){

      const formData = new FormData();
      formData.append('form_data_1', "");
      formData.append('form_data_2', "");

      this.form.post(`/reports/${this.issues}/generate/${target}`, {
          preserveState: false,
          preserveScroll: true,
          onSuccess: () => {
            
          }
      })                
        
            
    },
    checkProcess(process){
      let listWorkFlow = this.issues.workflows;
      let newLabel = "";
      var hasUpdate = false;
      listWorkFlow.forEach((wf) => {
          if(wf.process == process) {
            newLabel = process  + " (" + this.formatDate(wf.created_at) + ")";
            hasUpdate = true; 
          }
        });
      if(hasUpdate){
        return newLabel;
      }else{
        return process; 
      }
    },    
    closeProcessForm(){
      this.form.errors.status = "";
      this.toggleProcess()
    },    
    processSubmission(){
      this.process = true;
      
      let listWorkFlow = this.issues.workflows;
      this.currentStep = 0;
      listWorkFlow.forEach((item) => {
        let action = this.issues.action;
        action.forEach((op) => {
          if(item.process == op.action) {
            this.currentStep = parseInt(op.weight);
          }
        });
      });
      this.toggleProcess()
    },
    updateSubmission(){
      
      if (typeof this.form.status === 'undefined') {
        this.form.errors.status = "no status selected";
        return;
      }

      
      this.form.processing = true;
      
      const data = {
        target_id: this.issues.id,
        status: this.form.status,
        message: this.form.message,
      };
      
      axios.post(`/issues/${this.issues.id}/workflows`, data)
        .then(response => {
          this.form.processing = false
          if(response.data.status == 'success'){
            this.toggleProcess()
            this.$page.props.flash.success = response.data.message
          }
        })
        .catch(error => { });

    },
    changeStatus(){
        if(this.form.status == 'approved'){
          var dt_current = moment();
          let new_expiry = dt_current.add(1, 'years').subtract(1, 'days').format('DD-MM-Y');
          this.form.expiry = new_expiry
        }
    },    
    formatDate(timestamp){
      return moment(timestamp).format("DD-MM-Y")
    },    
    loadUpload(upload){
      this.upload = "update";
      this.form.upload_id = upload.id;
      this.form.upload_description = upload.description;
      this.form.upload_filetype = upload.filetype;
      this.form.upload_path = upload.upload_path;
      

      if(upload.path!=""){
        this.file_attached = true
      }else{
        this.file_attached = false
      }

      this.form.upload_attachments = upload.fileObj;
      this.toggleUpload()
    },
    formUpload(){
      this.upload = "create";
      this.form.upload_id = "";
      this.form.upload_description = "";
      this.form.upload_filetype = "";
      this.form.upload_path = "";
      this.form.upload_attachments = "";
      this.file_attached = false
      this.toggleUpload()
    },
    updateUpload(){
      if(this.upload == "create"){
        this.form.upload_id = Math.floor(new Date().valueOf() * Math.random());
       
        this.uploads.push({id:this.form.upload_id,
                           upload : "create",
                           description:this.form.upload_description,
                           filetype: this.form.upload_filetype,
                           path: this.form.upload_path,
                           fileObj : this.form.upload_attachments,
                          });
      }else{
        this.uploads.forEach((upload) => {
          if(upload.id == this.form.upload_id){
             upload.upload = "update";
             upload.description = this.form.upload_description;
             upload.filetype = this.form.upload_filetype;
             upload.path = this.form.upload_path;
             upload.fileObj = this.form.upload_attachments;
          }  
        }); 
      }
      this.toggleUpload()
    },
    loadAttachment(attachment, upload){

      let target = "";

      if(attachment=='file_attached'){
        target = upload;
      }
      
      window.open(target, '_blank');    
    },    
    loadIndividual(individual){
      this.individual = "update";
      this.form.individual_id = individual.id;
      this.form.individual_name = individual.name;
      this.form.individual_agency = individual.agency;
      this.form.individual_position = individual.position;
      this.toggleIndividual()
    },
    formIndividual(){
      this.individual = "create";
      this.form.individual_id = "";
      this.form.individual_name = "";
      this.form.individual_agency = "";
      this.form.individual_position = "";
      this.toggleIndividual()
    },
    updateIndividual(){
      if(this.individual == "create"){
         this.form.individual_id = Math.floor(new Date().valueOf() * Math.random());
         this.individuals.push({id:this.form.individual_id,
                                individual: "create",
                                name:this.form.individual_name,
                                agency: this.form.individual_agency,
                                position: this.form.individual_position,
                          });
      }else{
        this.individuals.forEach((individual) => {
          if(individual.id == this.form.individual_id){
            individual.individual = "update",
            individual.name = this.form.individual_name;
            individual.agency = this.form.competent_certificate;
            individual.position = this.form.competent_restriction;
          }  
        }); 
      }
      this.toggleIndividual()
    },  
    getIncidentTime(time){
      
      
      let timeArr = time.split(':');
      //console.log(time);

      let match_time = {hours: timeArr[0], minutes: timeArr[1], seconds: 0};

      return match_time
    },     
    runme(){

    },
    removeRecord(target, item){
      if (confirm('Are you sure you want to remove this record?')) {

        const formData = new FormData();
          formData.append('target', target);
          formData.append('item', item);

          axios.post(`/issues/${this.issues.id}/cancel`, formData).then(response => {
        
            if(target=="uploads"){
              this.uploads = this.uploads.filter(upload => !(upload.id == item));
              this.toggleUpload()
            }
                
            if(target=="individual"){
              this.competents = this.competents.filter(competent => !(competent.id == item));
              this.toggleIndividual()
            }
            
            }).catch(error => { });   
          
        }
    },
    getCurrentProcess(curr_stat, issue){
      
      let actions = issue.action;
      let currentProcess = actions.find(item => item.action === curr_stat) || { action_label: "draf" };
      
      return currentProcess.action_label.toUpperCase()
    }                
  },
}
</script>
